import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { ApplicationFlowUpdate } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow_update';

export default class EditBusinessController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
  @service router;

  @action async onUpdateBusiness(businessUpdate) {
    try {
      if (!this.addressValidation.didShowBusinessValidation) {
        await this.addressValidation.validateAndStandardizeBusiness(
          businessUpdate.address
        );
      }

      let hasSignificantChanges = false;

      const applicationFlowUpdate = new ApplicationFlowUpdate.Builder()
        .id(this.currentApplicationFlow.id)
        .business(businessUpdate)
        .build();

      if (
        !this.addressValidation.businessFailedValidation &&
        !this.addressValidation.didShowBusinessValidation
      ) {
        applicationFlowUpdate.business.address =
          this.addressValidation.businessStandardizedAddress;
        hasSignificantChanges = this.addressValidation.hasSignificantChanges(
          this.addressValidation.businessStandardizationChanges
        );
      }

      await this.currentApplicationFlow.update(applicationFlowUpdate);

      if (
        this.addressValidation.businessFailedValidation &&
        !this.addressValidation.didShowBusinessValidation
      ) {
        set(this, 'addressValidation.didShowBusinessValidation', true);
        this.router.transitionTo('signup.confirm-business.invalid-address');
      } else if (hasSignificantChanges) {
        set(this, 'addressValidation.didShowBusinessValidation', true);
        this.router.transitionTo('signup.confirm-business.address');
      } else {
        this.router.transitionTo('signup.confirm-business');
      }
    } catch (error) {
      this.send('handleRpcError', error);
    }
  }
}
